<template>
  <el-container :class="classes">
    <el-header v-if="showHeaderComputed" height="fit-content" :class="headerClass">
      <slot name="header"></slot>
    </el-header>
    <el-main ref="container" :class="containerClass">
      <slot></slot>
    </el-main>
    <el-footer v-if="showFooterComputed" :height="footerHeight + 'px'" :class="footerClass">
      <portal to="app-footer" :disabled="!portalFooter">
        <slot name="footer"></slot>
      </portal>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  props: {
    prefixCls: String,
    headerHeight: Number,
    footerHeight: Number,
    portalFooter: Boolean,
  },
  provide() {
    return {
      $layout: this,
    };
  },
  computed: {
    classes() {
      return [
        "tg-layout",
        this.prefixCls ? this.prefixCls + "--wrapper" : null,
        {
          "is-mobile": this.isMobile,
        },
      ];
    },
    containerClass() {
      return [
        "tg-layout--container",
        this.prefixCls ? this.prefixCls + "--container" : null,
        {
          "is-mobile": this.isMobile,
        },
      ];
    },
    headerClass() {
      return [
        "tg-layout--header",
        this.prefixCls ? this.prefixCls + "--header" : null,
        {
          "is-mobile": this.isMobile,
        },
      ];
    },
    footerClass() {
      return [
        "tg-layout--footer",
        this.prefixCls ? this.prefixCls + "--footer" : null,
        {
          "is-mobile": this.isMobile,
        },
      ];
    },
    showHeaderComputed() {
      return !!this.$scopedSlots["header"];
    },
    showFooterComputed() {
      return !!this.$scopedSlots["footer"];
    },
  },
};
</script>
